import { useState } from 'react';
import { Button, Card, Collapse } from 'react-bootstrap';
import { FaChevronDown, FaChevronUp, FaPalette } from 'react-icons/fa';
import { getStatusColor } from 'utils/statusColors';

// Todos os status da sua palette para exibição dinâmica
const LISTA_STATUS = [
  'Alto Custo',
  'Reservado',
  'Marcada',
  'Atendido',
  'Em Atendimento',
  'Faltou',
  'Não Realizou',
  'Faturado',
  'Solicitado',
  'Encaminhado',
  'Desmarcada',
  'Cancelado',
  'Em Preparo',
  'Em Eletro',
  'Laudado',
  'Chamado',
  'Aberta',
];

const LEGENDA_CONFIRMA = [
  { label: 'Confirmada', color: '#03fe31', textColor: '#000' },
  { label: 'Cancelar', color: '#dc3545', textColor: '#fff' },
  { label: 'Reagendar', color: '#ff07d2', textColor: '#fff' },
  { label: 'Atendente', color: '#2904fd', textColor: '#fff' },
];

export default function Legenda({ minimizadoPadrao = true }) {
  const [aberto, setAberto] = useState(!minimizadoPadrao);

  return (
    <Card
      className="shadow-sm border border-secondary-subtle"
      style={{
        fontSize: '0.7rem',
        maxWidth: '270px',
        backgroundColor: '#f8f9fa',
      }}
    >
      {/* Cabeçalho Clicável */}
      <Card.Header
        className="p-1 px-2 d-flex justify-content-between align-items-center bg-white border-bottom-0"
        style={{ cursor: 'pointer', userSelect: 'none' }}
        onClick={() => setAberto(!aberto)}
      >
        <span className="fw-bold text-secondary d-flex align-items-center gap-1">
          <FaPalette size={11} className="text-primary" /> Legenda de Cores
        </span>
        <Button variant="link" size="sm" className="p-0 text-muted border-0">
          {aberto ? <FaChevronUp size={10} /> : <FaChevronDown size={10} />}
        </Button>
      </Card.Header>

      {/* Conteúdo Sanfona */}
      <Collapse in={aberto}>
        <div>
          <Card.Body className="p-2 pt-0 border-top">
            <div className="fw-semibold text-muted mb-1" style={{ fontSize: '0.65rem' }}>
              SITUAÇÃO DA AGENDA
            </div>

            {/* Grid 2 colunas */}
            <div className="d-grid gap-1" style={{ gridTemplateColumns: '1fr 1fr' }}>
              {LISTA_STATUS.map((status) => {
                // Obtém exatamente o objeto de estilo retornado pela sua função getStatusColor
                const style = getStatusColor(status);

                return (
                  <div
                    key={status}
                    className="d-flex align-items-center px-1 rounded text-truncate"
                    style={{
                      backgroundColor: style.backgroundColor || '#ffffff',
                      color: style.color || '#000000',
                      fontWeight: style.fontWeight,
                      border: '1px solid rgba(0,0,0,0.15)',
                      lineHeight: '1.1',
                      paddingTop: '1px',
                      paddingBottom: '1px',
                    }}
                    title={status}
                  >
                    <span
                      className="d-inline-block rounded-circle me-1 flex-shrink-0"
                      style={{
                        width: '5px',
                        height: '5px',
                        backgroundColor: style.color || '#000000',
                      }}
                    />
                    <span
                      className="text-truncate"
                      style={{
                        fontSize: '0.6rem',
                        textDecoration: style.textDecoration,
                      }}
                    >
                      {status}
                    </span>
                  </div>
                );
              })}
            </div>

            {/* Status da Confirmação */}
            <div className="fw-semibold text-muted mt-2 mb-1" style={{ fontSize: '0.65rem' }}>
              CONFIRMAÇÃO
            </div>
            <div className="d-grid gap-1" style={{ gridTemplateColumns: '1fr 1fr' }}>
              {LEGENDA_CONFIRMA.map((item) => (
                <div
                  key={item.label}
                  className="d-flex align-items-center px-1 rounded text-truncate"
                  style={{
                    backgroundColor: item.color,
                    color: item.textColor,
                    fontSize: '0.67rem',
                    fontWeight: 'bold',
                    lineHeight: '1.2',
                    paddingTop: '2px',
                    paddingBottom: '2px',
                  }}
                >
                  <span className="text-truncate">{item.label}</span>
                </div>
              ))}
            </div>
          </Card.Body>
        </div>
      </Collapse>
    </Card>
  );
}
